import type { IconData } from '@stacksjs/iconify-core'

export const logoSoundcloud2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 16.765h-1.53v-1.52h-1.52v-1.53h-3.05v1.53h-1.52v1.52h-1.52v-1.52h1.52v-1.53h1.52v-3.05h-1.52v-1.52h-1.52v-1.52h-3.05v-1.53h-3.05v19.81h12.19v-1.52h1.52v-1.52h1.53v-1.53H32v-3.05h-1.52zm-18.29-9.14h1.53v18.28h-1.53Zm-3.04 1.52h1.52v16.76H9.15Zm-3.05 4.57h1.52v12.19H6.1Zm-3.05 0h1.52v10.67H3.05ZM0 16.765h1.53v6.1H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoSoundcloud2
